import { MenuItem,  } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { ISpedTabela } from "../../model";

export const TabelaSpedSelect = Select.ofType<ISpedTabela>();

export const filterItens: ItemPredicate<ISpedTabela> = (query, item) => {

  return `${item.codigo} - ${item.descricao}`.toLowerCase().indexOf(query.toLowerCase()) >= 0;

};

export const returnLabel = (item: ISpedTabela) => {

  let new_label = `${item.codigo} - ${item.descricao}`

  return (<div style={{ width: "100%" }} title={new_label}>{new_label}</div>)

}

export const renderItens: ItemRenderer<ISpedTabela> = (item, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={item.codigo}
      text={returnLabel(item)}
      onClick={handleClick}
    />
  );
};
